//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Slick from 'vue-slick';

export default {
  data: function () {
    return {
      slick: undefined,
      isMenuOpened: false
    };
  },
  props: {
    siteLanguage: String
  },
  components: {
    Slick
  },
  methods: {
    handleSlickChange: function (event, slick) {
      this.slick = slick;
    }
  },
  computed: {
    slickOptions: function () {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: false,
        vertical: true, 
        autoplay: true,
        autoplaySpeed: 4000
      };
    }
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/hero-slider/HeroSlider.vue